<script lang="ts" setup>
import AirlineOrderGroupingTable from "@/data-views/tables/airline_order_grouping/AirlineOrderGroupingTable.vue";
definePage({
  meta: {
    action: "read",
    subject: "AirlineOrder",
  },
});
</script>

<template>
  <VRow class="match-height">
    <VCol cols="12">
      <AirlineOrderGroupingTable />
    </VCol>
  </VRow>
</template>
